import styled from 'styled-components';

export const Container = styled.aside`
  grid-area: selectorMobile;
  width: 100%;
  display: flex;
  padding-left:2% ;
  justify-content: center;
  @media (min-width: 821px) {
      display: none;
   }
`;
export const Container2 =styled.div`
  width: 90%;
  margin-top: 50px;
  small{
    font: normal normal bold 10px/12px Poppins;
    letter-spacing: 2px;
    color: #C4C3C3;
  }

  .flex{
    display:flex;
    margin-top: 5%;
    width: auto;

    p{
      margin-left: 10px;
      font-weight: 600;
      font-size: 14px;
    }
  }
`
export const LayerContainerMobile = styled.div`
width: 56px;
height: 75px;
display: flex;
margin-right: 10px;
margin-top: 15px;
flex-direction: column;
align-items: center;
justify-content: space-between;
`
export const ContainerBox = styled.div`
display: flex;
flex-wrap: wrap;

.wrrap{
  display: flex;
flex-wrap: wrap;
}
p{
  margin: 0;
}
p:first-child{
  font-size: 12px;
  text-align: left;
  color: black;
  font-weight: bold;

}
`

export const Search = styled.div`
width:  318px;
height: 34px;
margin-top: 7% ;
border: 1px solid #C4C3C3;
border-radius: 50px;
align-self: center;
display: flex ;
align-items: center;
padding-left: 4% ;

p{
  margin-left: 2%;
  font-weight: 600;
  font-size:17px !important ;
}
@media (min-width: 821px) {
      display: none;
   }
`